import api from './api';
import type { Paginated, Role, User } from '../types/api';


export async function listUsers(params?: { role?: Role; is_verified?: boolean; page_size?: number; search?: string }) {
  const { data } = await api.get<Paginated<User> | User[]>('/auth/users/', { params });
  return Array.isArray(data) ? data : data.results;
}

export async function createUser(payload: Partial<User> & { password?: string }) {
  const { data } = await api.post<User>('/auth/users/', payload);
  return data;
}

export async function updateUser(id: number, payload: Partial<User>) {
  const { data } = await api.patch<User>(`/auth/users/${id}/`, payload);
  return data;
}

export async function deleteUser(id: number) {
  await api.delete(`/auth/users/${id}/`);
}

export async function changeRole(id: number, role: Role) {
  const { data } = await api.post<User>(`/auth/users/${id}/change_role/`, { role });
  return data;
}

export async function toggleVerified(id: number) {
  const { data } = await api.post<User>(`/auth/users/${id}/toggle_verified/`);
  return data;
}

export async function adminResetPassword(id: number, newPassword: string) {
  await api.post(`/auth/users/${id}/admin-reset-password/`, { new_password: newPassword });
}
